import * as Yup from 'yup';

export const validationSchemaUserInformation = Yup.object({
  firstName: Yup.string()
    .required('First name must be longer than or equal to 1 characters')
    .min(1, 'First name must be longer than or equal to 1 characters'),
  lastName: Yup.string()
    .required('Last name must be longer than or equal to 1 characters')
    .min(1, 'Last name must be longer than or equal to 1 characters'),
});

export const validationSchemaThrottlingSetting = Yup.object({
  restLimit: Yup.number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .typeError('Rest limit must be a number')
    .positive('Rest limit must be a positive number')
    .integer('Rest limit must be an integer'),
  restTtl: Yup.number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .typeError('Rest ttl must be a number')
    .positive('Rest ttl must be a positive number')
    .integer('Rest ttl must be an integer'),
});
